import { createRoot } from 'react-dom/client';
import BestAvailableApp from './components/app';
import { Provider } from 'react-redux';
import store from './app/store';
import * as React from 'react';

const root = createRoot(document.getElementById('bestAvailableApp'));
root.render(
    <Provider store={store}>
        <BestAvailableApp />
    </Provider>
);